"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceAuthorization = exports.AuthenticatedDevice = exports.UserAuthorization = exports.SvixAuthorization = exports.AuthenticatedUser = exports.UserAuthMethod = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Error = __importStar(require("./error"));
/** How the request was authenticated via {@link UserAuthorization}. */
exports.UserAuthMethod = {
    Bearer: 'bearer',
    Sat: 'sat',
};
class AuthenticatedUser extends effect_1.Context.Tag('AuthenticatedUser')() {
}
exports.AuthenticatedUser = AuthenticatedUser;
/**
 * Svix webhook signature.
 *
 * Verification needs three headers together (`svix-id`, `svix-timestamp`,
 * `svix-signature`). OpenAPI security requirements cannot express "all of
 * these", and Effect emits several schemes as alternatives, so only `svix-id`
 * is the scheme; the other two are documented in its description and, for
 * generated clients, as required header parameters by
 * `Culligan.Api.OpenApi.Security.SvixWebhook`.
 */
class SvixAuthorization extends platform_1.HttpApiMiddleware.Tag()('SvixAuthorization', {
    failure: Error.NotAuthenticatedErrorFromProtocol,
    security: {
        svixIdToken: platform_1.HttpApiSecurity.apiKey({ key: 'svix-id' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Svix webhook signature. The `svix-timestamp` and `svix-signature` headers are required ' +
            'as well: the signature is an HMAC-SHA256 over `{svix-id}.{svix-timestamp}.{body}` ' +
            'with the endpoint secret, as sent by Svix.')),
    },
}) {
}
exports.SvixAuthorization = SvixAuthorization;
class UserAuthorization extends platform_1.HttpApiMiddleware.Tag()('UserAuthorization', {
    failure: Error.NotAuthenticatedErrorFromProtocol,
    provides: AuthenticatedUser,
    security: {
        bearer: platform_1.HttpApiSecurity.bearer.pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Authenticate using a bearer token which can be obtained from the ' +
            'v1/auth/login API endpoint')),
        sat: platform_1.HttpApiSecurity.apiKey({ key: 'sat', in: 'query' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Authenticate using a SAT token')),
        cPortToken: platform_1.HttpApiSecurity.apiKey({ key: 'authorization' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Authenticate using a CPort token')),
        // NOTE: We're currently not using the apple passkit tokens
        // applePassKitToken: HttpApiSecurity.apiKey({ key: 'authorization' }),
    },
}) {
}
exports.UserAuthorization = UserAuthorization;
class AuthenticatedDevice extends effect_1.Context.Tag('AuthenticatedUser')() {
}
exports.AuthenticatedDevice = AuthenticatedDevice;
class DeviceAuthorization extends platform_1.HttpApiMiddleware.Tag()('DeviceAuthorization', {
    failure: Error.NotAuthenticatedErrorFromProtocol,
    provides: AuthenticatedDevice,
    security: {
        certificate: platform_1.HttpApiSecurity.apiKey({ key: 'x-culligan-device-id' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Note that an additional header containing the certificate is also required')),
    },
}) {
}
exports.DeviceAuthorization = DeviceAuthorization;
//# sourceMappingURL=authorization.js.map